module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point01/th_03-14ae0f3a1681b3c15875e5da9e710c97.jpg";